import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'



export async function postRegisterLinkAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization/link', value)
}
export async function putRegisterLinkAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/organization/link', value)
}
export async function getLinkByorganizationIdAndServiceAPI(value: string,service:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/link-service/'+value+"/"+service, {})
}
export async function getLinkByorganizationIdAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/link/'+value, {})
}



export async function deleteParentUserGroupAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/organization/parentuser-group?id='+value, {})
}

export async function postRegisterParentUserGroupAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization/parentuser-group', value)
}

export async function deleteOrganizationsByParentOrganizationIdAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/organization/organizationparent/'+value, {})
}

export async function postOrganizationsByParentOrganizationIdAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization/organizationparent', value)
}

export async function getOrganizationsByParentOrganizationIdAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/organizationparent/'+value, {})
}

export async function getTypeOrganizationsByEmissionSourceIdAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/typeorganization/'+value, {})
}

export async function postRegisterTypeOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization/typeorganization', value)
}
export async function putTypeOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/organization/typeorganization', value)
}
export async function getTypeOrganizationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/typeorganization', {})
}


export async function getAllCitiesByOrganizationAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/cities?organizationId='+value, {})
}
export async function getStylesByOrganizationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/styles', {})
}

export async function getValidateOrganizationAPI(value: String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/validate/'+value, {})
}
export async function getAllOrganizationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization', {})
}
export async function getOrganizationByIdAPI(value:String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/organization/id/'+value, {})
}
export async function postRegisterOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/organization', value)
}
export async function putUpdateOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/organization', value)
}
export async function putActiveOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/organization/active', value)
}
export async function deleteInactiveOrganizationAPI(value: String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/organization/'+value, {})
}
export async function deleteOrganizationByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/organization?id='+value, {})
}

export async function getParentOrganizationsByUserIdAPI() : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/organization/parentorganization', {})
}